<template>
  <div class="p-6 bg-gray-600 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-sm">
      <img src="/images/logo.png" class="h-32 mx-auto" alt="Casa Auto">
      <form class="mt-6 overflow-hidden" @submit.prevent="submit">
        <div class="mt-12">
          <text-input v-model="form.email" :data-error="error('email')" :label="__('Email')" type="email" autofocus autocapitalize="off"/>
          <text-input v-model="form.password" class="mt-6" :label="__('Password')" type="password"/>
        </div>

        <div class="mt-12 flex justify-center">
          <loading-button :loading="sending" class="uppercase px-12 py-4 bg-coral-400 text-white text-2xl font-light" type="submit">
            {{ __("Login") }}
          </loading-button>
        </div>
      </form>

      <div v-if="loginLinks.length" class="mt-10 bg-gray-700 border border-gray-500 rounded p-4">
        <div class="text-xs uppercase tracking-wide text-gray-300 mb-3">Local login links</div>
        <div class="space-y-2">
          <a
            v-for="link in loginLinks"
            :key="link.id"
            :href="link.url"
            class="block px-3 py-2 rounded bg-gray-600 hover:bg-gray-500 text-white"
          >
            <span class="block text-sm font-semibold">{{ link.name }}</span>
            <span class="block text-xs text-gray-300">{{ link.email }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LoadingButton from '@/Shared/LoadingButton'
  import Logo from '@/Shared/Logo'
  import TextInput from '@/Shared/TextInput'

  export default {
    components: {
      LoadingButton,
      Logo,
      TextInput,
    },
    props: {
      errors: Object,
      loginLinks: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        sending: false,
        form: {
          email: null,
          password: null,
          remember: null,
        },
      }
    },
    mounted() {
      document.title = this.__("Login")
    },
    methods: {
      submit() {
        this.sending = true;
        this.$inertia.post(this.route('login.attempt'), {
          email: this.form.email,
          password: this.form.password,
          remember: this.form.remember,
        }).then(() => this.sending = false)
      },
    },
  }
</script>
